"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _memberManagement = require("@/api/member/memberManagement");
var _goods_activity_combo = require("@/api/goods_activity/goods_activity_combo");
var _index = require("@/utils/index");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '用户充值记录',
  props: {
    memberData: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      // 搜索表单数据
      searchForm: {
        platform: '',
        // 平台类型：wx微信，alipay支付宝
        amount: '',
        // 充值金额
        mobilePhone: '',
        // 手机号
        tradeNo: '',
        // 交易流水号
        posTradeNo: '',
        // POS流水号
        shopName: '',
        // 门店名称
        source: '',
        // 来源：1线上充值，2扫码充值
        value1: [],
        // 时间范围：[开始时间, 结束时间]
        shopId: '',
        // 门店ID
        payStatus: '',
        // 支付状态
        status: '',
        // 状态
        userId: null // 用户ID，在点击储值按钮时赋值
      },
      // 门店列表
      storeList: [],
      // 表格数据
      tableData: [],
      // 加载状态
      loading: false,
      // 分页相关
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // 类型映射数据（筛选和表格渲染共用）
      sourceOptions: [{
        value: '1',
        label: '线上充值'
      }, {
        value: '2',
        label: '扫码充值'
      }, {
        value: '3',
        label: '线下充值'
      }],
      saleTypeOptions: [{
        value: '0',
        label: '餐饮(windows)'
      }, {
        value: '1',
        label: 'CRM'
      }, {
        value: '2',
        label: '餐饮6'
      }, {
        value: '3',
        label: '微信'
      }, {
        value: '4',
        label: '支付宝'
      }, {
        value: '5',
        label: 'CRMAPI7'
      }, {
        value: '6',
        label: '外卖'
      }, {
        value: '7',
        label: '微信外卖'
      }, {
        value: '8',
        label: '百度外卖'
      }, {
        value: '9',
        label: '天财线下POS'
      }],
      platformOptions: [{
        value: 'wx',
        label: '微信'
      }, {
        value: 'ali',
        label: '支付宝'
      }, {
        value: 'tc',
        label: '天财'
      }, {
        value: 'cdp',
        label: 'CDP'
      }],
      payStatusOptions: [{
        value: '0',
        label: '未付款'
      }, {
        value: '1',
        label: '已付款'
      }, {
        value: '3',
        label: '退款中'
      }, {
        value: '4',
        label: '已退款'
      }],
      statusOptions: [{
        value: '0',
        label: '未支付'
      }, {
        value: '1',
        label: '预支付'
      }, {
        value: '2',
        label: '已充值'
      }, {
        value: '3',
        label: '确认充值'
      }, {
        value: '9',
        label: '已撤销'
      }]
    };
  },
  methods: {
    // 搜索功能
    handleSearch: function handleSearch() {
      this.currentPage = 1;
      this.fetchRechargeRecords();
    },
    // 获取储值记录列表
    fetchRechargeRecords: function () {
      var _fetchRechargeRecords = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              _context.prev = 1;
              params = _objectSpread(_objectSpread({}, this.searchForm), {}, {
                page: this.currentPage,
                // 当前页码
                limit: this.pageSize // 每页条数
              }); // 处理时间范围，将value1数组转换为startTime和endTime
              if (params.value1 && Array.isArray(params.value1) && params.value1.length === 2) {
                params.startTime = params.value1[0];
                params.endTime = params.value1[1];
              }
              // 删除value1字段，因为后端需要startTime和endTime
              delete params.value1;

              // 过滤空值参数
              Object.keys(params).forEach(function (key) {
                if (params[key] === '' || params[key] === null || params[key] === undefined) {
                  delete params[key];
                }
              });
              _context.next = 2;
              return (0, _memberManagement.xyUserAccountPage)(params);
            case 2:
              response = _context.sent;
              if (response.code === 200) {
                this.tableData = response.records || [];
                this.total = response.total || 0;
              } else {
                this.$message.error(response.message || '获取储值记录失败');
              }
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              console.error('获取储值记录失败:', _t);
              this.$message.error('获取储值记录失败');
            case 4:
              _context.prev = 4;
              this.loading = false;
              return _context.finish(4);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function fetchRechargeRecords() {
        return _fetchRechargeRecords.apply(this, arguments);
      }
      return fetchRechargeRecords;
    }(),
    // 导出功能
    handleExport: function () {
      var _handleExport = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, response, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              this.$message.info('正在导出储值记录数据...');
              params = _objectSpread({}, this.searchForm); // 处理时间范围，将value1数组转换为startTime和endTime
              if (params.value1 && Array.isArray(params.value1) && params.value1.length === 2) {
                params.startTime = params.value1[0];
                params.endTime = params.value1[1];
              }
              // 删除value1字段，因为后端需要startTime和endTime
              delete params.value1;

              // 过滤空值参数
              Object.keys(params).forEach(function (key) {
                if (params[key] === '' || params[key] === null || params[key] === undefined) {
                  delete params[key];
                }
              });
              _context2.next = 1;
              return (0, _memberManagement.exportRechargeRecords)(params);
            case 1:
              response = _context2.sent;
              if (response && response.code === 0) {
                this.$message.success(response.message || '导出中，请稍后查看');
              } else {
                this.$message.error(response.message || '导出失败');
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              console.error('导出失败:', _t2);
              this.$message.error('导出失败：' + (_t2.message || '网络异常'));
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function handleExport() {
        return _handleExport.apply(this, arguments);
      }
      return handleExport;
    }(),
    // 退款操作
    handleRefund: function handleRefund(row) {
      var _this = this;
      this.$confirm("\u786E\u8BA4\u9000\u6B3E\u5F53\u524D\u50A8\u503C", '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // TODO: 实现退款逻辑
        (0, _memberManagement.retMoney)(row.id).then(function (res) {
          if (res.code === 0) {
            _this.$message.success('退款成功');
            _this.fetchRechargeRecords(); // 重新获取数据
          } else {
            _this.$message.error('退款失败');
          }
        }).catch(function () {
          _this.$message.error('退款失败');
        });
      }).catch(function () {
        _this.$message.info('已取消退款');
      });
    },
    // 支付操作
    handlePay: function handlePay(row) {
      var _this2 = this;
      this.$confirm("\u786E\u8BA4\u7528\u6237\u5DF2\u652F\u4ED8", '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // TODO: 实现支付逻辑
        (0, _memberManagement.payRecharge)(row.id).then(function (res) {
          if (res.code === 0) {
            _this2.$message.success('支付成功');
            _this2.fetchRechargeRecords(); // 重新获取数据
          } else {
            _this2.$message.error('支付失败');
          }
        }).catch(function () {
          _this2.$message.error('支付失败');
        });
        // this.payRechargeRecord(row.id)
        // this.fetchRechargeRecords() // 重新获取数据
      }).catch(function () {
        _this2.$message.info('已取消支付');
      });
    },
    // 确认操作
    handleConfirm: function handleConfirm(row) {
      var _this3 = this;
      this.$confirm("\u786E\u8BA4\u50A8\u503C", '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _memberManagement.confirmRecharge)(row.id).then(function (res) {
          if (res.code === 0) {
            _this3.$message.success('确认成功');
            _this3.fetchRechargeRecords(); // 重新获取数据
          } else {
            _this3.$message.error('确认失败');
          }
        }).catch(function () {
          _this3.$message.error('确认失败');
        });
        // this.confirmRechargeRecord(row.id)
        // this.fetchRechargeRecords() // 重新获取数据
      }).catch(function () {
        _this3.$message.info('已取消确认');
      });
    },
    // 撤销操作
    handleRevoke: function handleRevoke(row) {
      var _this4 = this;
      this.$confirm("\u786E\u8BA4\u64A4\u9500\u5F53\u524D\u50A8\u503C", '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _memberManagement.retRecharge)(row.id).then(function (res) {
          if (res.code === 0) {
            _this4.$message.success('撤销成功');
            _this4.fetchRechargeRecords(); // 重新获取数据
          } else {
            _this4.$message.error('撤销失败');
          }
        }).catch(function () {
          _this4.$message.error('撤销失败');
        });
        // this.revokeRechargeRecord(row.id)
        // this.fetchRechargeRecords() // 重新获取数据
      }).catch(function () {
        _this4.$message.info('已取消撤销');
      });
    },
    // 分页大小改变
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchRechargeRecords();
    },
    // 当前页改变
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchRechargeRecords();
    },
    // 格式化时间
    formatTime: function formatTime(time) {
      if (!time) return '';
      return (0, _index.parseTime)(time, '{y}-{m}-{d} {h}:{i}:{s}');
    },
    // 根据 value 获取对应 label 的通用方法
    getLabelByValue: function getLabelByValue(options, value) {
      var item = options.find(function (opt) {
        return opt.value === String(value);
      });
      return item ? item.label : '未知';
    },
    // 获取来源文本
    getSourceText: function getSourceText(source) {
      return this.getLabelByValue(this.sourceOptions, source);
    },
    // 获取交易来源文本
    getSaleTypeText: function getSaleTypeText(saleType) {
      return this.getLabelByValue(this.saleTypeOptions, saleType);
    },
    // 获取平台类型文本
    getPlatformText: function getPlatformText(platform) {
      return this.getLabelByValue(this.platformOptions, platform);
    },
    // 获取支付状态文本
    getPayStatusText: function getPayStatusText(payStatus) {
      return this.getLabelByValue(this.payStatusOptions, payStatus);
    },
    // 获取状态文本
    getStatusText: function getStatusText(status) {
      return this.getLabelByValue(this.statusOptions, status);
    },
    // 获取门店列表
    getStoreList: function () {
      var _getStoreList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response, stores, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 1;
              return (0, _goods_activity_combo.queryRegionStoreList)();
            case 1:
              response = _context3.sent;
              if (response.code === 200 && response.data && response.data.storeRegions) {
                // 处理返回的数据格式，将storeRegions中的storeList扁平化为一个数组
                stores = [];
                response.data.storeRegions.forEach(function (region) {
                  if (region.storeList && region.storeList.length > 0) {
                    region.storeList.forEach(function (store) {
                      stores.push({
                        id: store.storeId,
                        storeName: store.storeName
                      });
                    });
                  }
                });
                this.storeList = stores;
              } else {
                this.$message.error('获取门店列表失败');
              }
              _context3.next = 3;
              break;
            case 2:
              _context3.prev = 2;
              _t3 = _context3["catch"](0);
              console.error('获取门店列表失败:', _t3);
              this.$message.error('获取门店列表失败');
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function getStoreList() {
        return _getStoreList.apply(this, arguments);
      }
      return getStoreList;
    }()
  },
  mounted: function mounted() {
    // 如果传入了会员数据，把 userId 赋值并设置手机号过滤
    if (this.memberData) {
      this.searchForm.userId = this.memberData.userId;
      this.searchForm.mobilePhone = this.memberData.mobilePhone || '';
      console.log('会员储值记录 - 会员信息:', this.memberData);
    }
    // 初始化时获取门店列表
    this.getStoreList();
    // 初始化时获取储值记录数据
    this.fetchRechargeRecords();
  }
};